<ng-container *ngIf="{
    row: columnData | async
  } as $">
<img *ngIf="isBeyondOneYear($.row.client_since,$.row.created_date)" [src]="'/assets/img/icons/'+crownType.crown+'.svg'" alt="Icon" />
</ng-container>
